var map = {
	"./music-instructions.json": 5234,
	"./music-library-intro2024.json": 5235,
	"./music-library-launch2024.json": 5236,
	"./music-progression.json": 5237,
	"./startSourcesAdvanced.json": 5238,
	"./startSourcesSimple.json": 5239,
	"./startSourcesSimple2.json": 5240,
	"./startSourcesTracks.json": 5241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4847;